import type { StrapiImage } from '@/services/StrapiService';

export const RESOURCE_TYPES = ['article', 'video', 'podcast'] as const;

export type ResourceType = (typeof RESOURCE_TYPES)[number];

export const RESOURCE_TYPE_LABELS: Record<ResourceType, string> = {
    article: 'Article',
    video: 'Video',
    podcast: 'Podcast',
};

export interface Resource {
    id: string;
    resourceType: ResourceType;
    title: string;
    slug?: string;
    description?: string;
    publishedAt?: string;
    createdAt?: string;
    updatedAt?: string;
    image?: StrapiImage;
    href: string;
    /**
     * Raw CMS targeting rules (ASA-1570), unparsed. Evaluated in the browser by
     * `isVisible`; absent means the resource is visible to everyone.
     */
    visibility?: unknown;
}
